<template>
    <LagenschemaEditor />
</template>

<script>
import LagenschemaEditor from './components/LagenschemaEditor.vue'

export default {
    name: 'App',
    components: {
        LagenschemaEditor
    }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
